import { Select as DigdirSelect, SelectOptgroup, SelectOption, } from "@digdir/designsystemet-react";
const Select = DigdirSelect;
Select.displayName = "Select";
export { Select, SelectOptgroup, SelectOption, };
//# sourceMappingURL=select.js.map